import showNotificationOnDelete from '../../helpers/showNotificationOnDelete';
import { ControlIcons } from 'owa-control-icons';
import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import loc, { format } from 'owa-localize';
import { undoAction } from 'owa-locstrings/lib/strings/undoaction.locstring.json';
import { MailIcons } from 'owa-mail-icons';
import { getListViewNotificationDimensions } from 'owa-mail-layout';
import * as undoActions from 'owa-mail-undo';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import {
    archiveItemSucceededNotification,
    archiveItemsSucceededNotification,
    moveItemSucceededNotification,
    moveItemsSucceededNotification,
} from './showNotificationOnMove.locstring.json';

/**
 * show notification on move or archive
 * @param numberOfItems acted on for the action
 * @param destinationFolderId for the move action
 * @param allowUndo whether this scenario supports an undo
 */
export default function showNotificationOnMove(
    numberOfItems: number,
    destinationFolderId: string,
    allowUndo: boolean
) {
    if (!getUserConfiguration().UserOptions.ShowNotificationBar) {
        return;
    }

    const destinationFolderName = getEffectiveFolderDisplayName(
        folderStore.folderTable.get(destinationFolderId)
    );
    const isArchive = folderIdToName(destinationFolderId) === 'archive';
    const isDelete = folderIdToName(destinationFolderId) === 'deleteditems';

    if (isDelete) {
        showNotificationOnDelete(numberOfItems, allowUndo);
        return;
    }

    let notificationText;

    if (isArchive) {
        notificationText =
            numberOfItems === 1
                ? loc(archiveItemSucceededNotification)
                : format(loc(archiveItemsSucceededNotification), numberOfItems);
    } else {
        notificationText =
            numberOfItems === 1
                ? format(loc(moveItemSucceededNotification), destinationFolderName)
                : format(loc(moveItemsSucceededNotification), numberOfItems, destinationFolderName);
    }
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute(
        'moveOrArchiveNotification',
        'MailModuleNotificationBarHost',
        notificationText,
        {
            icon: isArchive ? ControlIcons.Archive : MailIcons.FabricMovetoFolder,
            primaryActionText: allowUndo ? loc(undoAction) : null,
            allowClear: true,
            // Want 12 px of padding on either side of the notificaiton bar
            minWidth: notificationDimensions.minWidth,
            maxWidth: notificationDimensions.maxWidth,
            notificationCallback: reason => {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    undoActions.lazyUndo.importAndExecute('NotificationBar');
                }
            },
        }
    );
}
